<template>
  <div class="inProduct_detail">
     <BannerIn :bannerUrl="bannerUrl" :positionInfo="positionInfo" />
     <NavIn :inNavInfo="inNavInfo"  />
      <section class="inDetailTopBox">
          <div class="wrapper">
              <div class="inDetailTop_img">
                <img :src="$root.$TEMP_URL+productDetail.ico" />
              </div>
              <div class="inDetailTop_word">
                  <div class="title">{{productDetail.title}}</div>
                  <div class="cenList" v-html="productDetail.ext_spec">
                  </div>
                  <a class="btn" :href="$root.$TEMP_URL+productDetail.ext_wenjian">
                    {{isZhong?'下载':'File Download'}}
                  </a>
              </div>
          </div>
      </section>
      <section class="inDetailContentBox">
          <div class="wrapper">
              <div class="inDetailContent_tit">
                   PRODUCT DESCRIPTION
              </div>
              <div class="inDetailContent" v-html="productDetail.content">
              </div>
          </div>
      </section>
      
  </div>
</template>

<script>
import BannerIn from '../../../components/BannerIn/BannerIn'
import NavIn from '../../../components/NavIn/NavIn'

import { getNav,getSort,getContent } from '../../../api'
export default {
  components:{
    BannerIn,
    NavIn,
  },
  data(){
    return{
      bannerUrl:'' ,
      inNavInfo:[
            {
                title:'Automatic Baling Machine',
                url:'#',
                selected:false
            },
            {
                title:'Spraying Marking Machine',
                url:'#',
                selected:false
            },
            {
                title:'TEC Sensor',
                url:'#',
                selected:true
            }
      ],
      positionInfo:{
          second:'PRODUCTS',
          third:'Automatic Baling Machine'
      },
      productDetail:{},
      isZhong:false

    }
  },
  async created(){

      const isZhong = this.$parent.isZhong;
      let resNav;
      let positionInfo = {};
      let res3;
 

      if(isZhong){
          resNav = await getNav(43);
          res3 = await getContent(this.$route.params.id);
          positionInfo={
              second:'产品中心',
              third:''
          }
      }else{
          resNav = await getNav(5);
          res3 = await getContent(this.$route.params.id);
          positionInfo={
              second:'PRODUCTS',
              third:''
          }
      }
      this.positionInfo = positionInfo;
      this.isZhong = isZhong; 


       //更新bannerIn
       const res2 = await getSort(5);
       this.bannerUrl = res2.data.pic;

       //二级分类
      let inNavInfo = resNav.data.map(v=>{
          return{
              title:v.name,
              url:'/products/productlist/'+v.scode,
              selected:false
          } 
      })
      
      inNavInfo.forEach((v,index)=>index===2?v.selected=true:v.selected=false);
      this.inNavInfo=inNavInfo;

      //详情
      this.productDetail = res3.data;
      

  },

}
</script>

<style lang="scss" scoped>
@import '../../../common/css/mixin.scss';
.inDetailTopBox {
  padding: 58px 0 98px 0;
  background: url(../ProductList/images/beijing01_def.jpg) no-repeat;
  background-size: cover;
  .wrapper {
     display: flex;
     justify-content: center;
     align-items: center;
    .inDetailTop_img {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 90%;
      }
    }
    .inDetailTop_word {
      width: 50%;
      .title {
        line-height: 52px;
        font-size: 32px;
        font-weight: bold;
      }
      .cenList {
        margin-top: 12px;
        line-height: 28px;
        background: url(./images/landian.png) left 28px repeat-y;
        padding-left: 18px;
        font-size: 14px;
      }
      .btn {
        margin-top: 36px;
        width: 168px;
        height: 56px;
        text-align: center;
        line-height: 56px;
        color: #fff;
        font-size: 16px;
        background: $themeColor;
        @include compatible(border-radius,8px) ;
        cursor: pointer;
            display: block;
      }
    }
  }
}

.inDetailContentBox {
  padding: 112px 0 46px 0;
  background: url(./images/beijing02.jpg) center top no-repeat;
  background-size: 100%;
  .wrapper {
    .inDetailContent_tit{
      font-weight: bold;
      font-size: 30px;
      padding: 58px 0 28px 0;
      background: #fff;
      text-align: center;
    }
    .inDetailContent {
      background: #fff;
      padding: 32px 12px;
      line-height: 32px;
      img,video{
        max-width: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Products/ProductDetail/ProductDetail.vue